export default "__VITE_ASSET__CCpo8H5Y__"